import { render, staticRenderFns } from "./approvalDetail.vue?vue&type=template&id=f399c3cc&scoped=true&"
import script from "./approvalDetail.vue?vue&type=script&lang=js&"
export * from "./approvalDetail.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetail.vue?vue&type=style&index=0&id=f399c3cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f399c3cc",
  null
  
)

export default component.exports